export default __webpack_public_path__ + "static/media/the-bodega-2400x1350.12e58e05.jpg";